/**
 * @deprecated 请使用 feature-flags.ts 替代
 */
const $f = {
    nodePlayerVersion: undefined,
    flvjsPlayerVersion: undefined,
    androidForbid: false,
    virtualUser: false,
    film: false,
    earlyFinishForbid: false,
    schoolContent: false,
    /** @desc 侧边栏显示连麦学员 */
    talkerSideLayout: false,
} as FeatureConfig;

export interface FeatureConfig {
    nodePlayerVersion?: string;
    flvjsPlayerVersion?: string;
    androidForbid?: boolean;
    virtualUser?: boolean;
    film?: boolean;
    earlyFinishForbid?: boolean;
    schoolContent?: boolean;
    talkerSideLayout?: boolean;
}

export const initFeatureConfig = (config: Partial<FeatureConfig>): void => {
    Object.assign($f, config);
}

export default $f;
